export default __webpack_public_path__ + "static/SRI 4220 - Product Specifications & Technical Data-9c740fdc0fca3c768fadd3cf842c2a72.pdf";